/* eslint-disable class-methods-use-this */
/* eslint-disable new-cap */
var ezdia;
(function (ezdia) {
    var actionObj = {};
    var pageParams = null;
    var rowTemplate = null;
    var widgettype = 'ez.diff';
    var wrapper = function (id) {
        var wrapperObj = $("#" + id);
        if (!wrapperObj.length) {
            var divs = $('<div>', {
                id: id
            });
            $('body').append(divs);
            wrapperObj = $("#" + id);
        }
        return wrapperObj;
    };
    var bindEvents = function () {
        var frm = $("#ez-diff-popup");
        frm.find('input[id^="diff_item_"]')
            .off('click')
            .on('click', function click() {
            toggleField.call(this);
        });
    };
    function toggleField() {
        var errorDiff = $(".error-diff");
        var id = this.id.split('diff_item_');
        id = id[1] ? id[1] : "";
        var checkbox = $("[name=\"diff-checkbox-" + id + "\"]");
        var labelField = $("#diff-label-" + id);
        checkbox.removeClass("diff-error");
        labelField.removeClass("diff-error");
        errorDiff.hide();
    }
    var findDiff = function (obj) {
        var diffMatchPatch = new diff_match_patch();
        var id = obj.id, inputData = obj.inputData;
        inputData.forEach(function (item) {
            item.fields.map(function (itemdata) {
                var originalDivId = itemdata.id + "-" + itemdata.name + "-original";
                var updatedDivId = itemdata.id + "-" + itemdata.name + "-updated";
                var text1 = document.getElementById(originalDivId).innerHTML;
                var text2 = document.getElementById(updatedDivId).innerHTML;
                text1 = text1.replace(/\n/g, '');
                text2 = text2.replace(/\n/g, '');
                var d = diffMatchPatch.diff_main(text1, text2);
                diffMatchPatch.diff_cleanupSemantic(d);
                var ds = diffMatchPatch.diff_prettyHtml(d);
                document.getElementById(originalDivId).innerHTML = ds;
                document.getElementById(updatedDivId).innerHTML = ds;
            });
        });
    };
    var createModel = function (obj) {
        var wrapperObj = wrapper('ez-diff-pop-up-wrapper');
        var content = null;
        var dataList = obj.data.unpublished_data.unpublishedDataList;
        var exObj = {
            id: obj.id,
            inputData: dataList
        };
        var context = $.extend({}, exObj);
        var template = ezdia.templates.diff.diffPopUp;
        var qaObj = obj.qaObj;
        var action = obj.action;
        content = template(context);
        wrapperObj.html(content);
        bindEvents();
        qaObj.selIds = obj.data.unpublished_ids;
        wrapperObj.dialog({
            modal: true,
            title: 'Publish',
            width: 1200,
            height: 'auto',
            buttons: [
                {
                    text: 'Ignore All and Publish',
                    class: 'btn',
                    click: function (event) {
                        qaObj.subAction = "ignore";
                        action.call(this, obj.eventObject, obj.qaObj, $(this));
                    }
                },
                {
                    text: 'Merge Selected',
                    class: 'btn-primary',
                    click: function (event) {
                        qaObj.subAction = "merge";
                        action.call(this, obj.eventObject, obj.qaObj, $(this));
                    }
                }
            ]
        });
        findDiff(exObj);
    };
    // eslint-disable-next-line import/prefer-default-export
    ezdia.createDiffPopUp = {
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
        create: function (type) {
            pageParams = $.ezdia.config.pageParams;
            createModel(type);
        }
    };
    /**
     * This line of code for support old code.
     * It should be removed in future
     */
    // $.ezdia.diff = createDiffPopUp;
})(ezdia || (ezdia = {}));
